export default __webpack_public_path__ + "static/media/about-us-section-three-arrow.2be2e95b.svg";